import React, { useEffect } from "react";
import { useHistory, withRouter } from "react-router-dom";

const ProductsByAccountComponent = (props) => {
  const history = useHistory();

  useEffect(() => {
    (async () => {
     await localStorage.setItem("skygeni-user-page", "Growth Modeling");
      await localStorage.setItem(
        "skygeni-user-growthModelingPage",
        "White Space Analysis + Products by Account - 2026"
      );
       await localStorage.removeItem("skygeni-user-repPage");
      await localStorage.removeItem("skygeni-user-productPage");
    await localStorage.removeItem("skygeni-user-SettingsPage");
    await localStorage.removeItem("skygeni-user-pipelineProgressionPage");
    await localStorage.removeItem("skygeni-user-pipelineVelocityandConversionPage")
    await localStorage.removeItem("skygeni-user--pipelineBuildandSuficencyPage")
    await localStorage.removeItem("skygeni-user-marketIntelandGrowthLeversPage");
    await localStorage.removeItem("skygeni-user-salesProductivityPage");
    await localStorage.removeItem("skygeni-user-growthScienceInsightsPage");
    await localStorage.removeItem("skygeni-user-personalizedScorecardsPage");
      history.push("/");
      window.location.reload();
    })();
  }, []);

  return <div style={{ margin: "1rem auto" }}>Loading...</div>;
};
let routerAddedProductsByAccount = withRouter(ProductsByAccountComponent);
export default routerAddedProductsByAccount;
